exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-documentos td, th {  \r\n\tborder: 1px solid #ddd;\r\n  \ttext-align: left;\r\n}\r\n\r\n.table-documentos {\r\n\tborder-collapse: collapse;\r\n\twidth: 100%;\r\n}\r\n\r\n.table-documentos th, td {\r\n\tpadding: 10px;\r\n}  ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/arquitectura/workspace/Form300/Diligenciamiento_IngresoIva300_1.0.0/Diligenciamiento_IngresoIva300_1.0.0/Angular/Iva300Ingreso/src/app/components/dialog-confirmacion/dialog-confirmacion.component.css
// module id = ../../../../../src/app/components/dialog-confirmacion/dialog-confirmacion.component.css
// module chunks = main